module.exports = __webpack_public_path__ + "videos/3d-model_en.37e8559.webm";